<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">QR Code</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
</div>

<div class="modal-body p-3">
  <qrcode [qrdata]="url" cssClass="d-flex justify-content-center" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
</div>
